let trigger;
let eventHandler;

export default class SameAsDeliveryCheckBox {
	constructor() {
		trigger = document.getElementById('sameAsAddressCheckBox');

		if (trigger) {
			eventHandler = evt => {
				this.toggleModifier('.address-form', '--read-only', evt);
				window.od.events.publish('state::change', { target: evt.target });
			};
			trigger.addEventListener('change', eventHandler, false);
		}
	}

	toggleModifier(blockElement, modifier, event) {
		const block = document.querySelector(blockElement);
		const blockClassName = blockElement.replace('.', '');

		if (
			block &&
			block.classList.contains(blockClassName + modifier) &&
			!event.target.checked
		) {
			block.classList.remove(blockClassName + modifier);
		} else if (block && block.classList.contains(blockClassName)) {
			block.classList.add(blockClassName + modifier);
		}

		return block;
	}
}
